import { GROWTH_BOOK_URL } from 'shared/constants';
// eslint-disable-next-line no-restricted-imports
import {
  GrowthBook,
  GrowthBookProvider,
  useFeatureIsOn as _useFeatureIsOn,
  useGrowthBook as _useGrowthBook,
} from '@growthbook/growthbook-react';
import { useEffect } from 'react';
import { getKeys } from 'shared/lib/object';

import type { LocalAppFeatures } from './features.local';
import { getLocalOnlyFeatures } from './features.local';

export const enum FEATURES {
  TIME_BLOCKING = 'show_disable_contractor_info',
  CUSTOM_SCHEDULE = 'cc_custom_schedule',
  ONBOARDING_ENABLED = 'onboarding_enabled',
}

export type FeatureKeys = keyof typeof FEATURES;
type GrowthBookAppFeatures = Record<(typeof FEATURES)[FeatureKeys], boolean>;

type AppFeatures = LocalAppFeatures & GrowthBookAppFeatures;

const growthbook = new GrowthBook({
  apiHost: GROWTH_BOOK_URL,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
});

const gbResponses = {
  fetchData: {},
  sdkData: {},
  fetchErrorMsg: '',
  sdkErrorMsg: '',
  isFetchDone: false,
};

// growthbook endpoint = apiHost + "/api/features/" + clientKey;
fetch(`${GROWTH_BOOK_URL}/api/features/${process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY}`)
  .then((res) => res.json())
  .then((data) => {
    gbResponses.isFetchDone = true;
    gbResponses.fetchData = data.features;
  })
  .catch((err) => {
    gbResponses.fetchErrorMsg = err.message;
  });

export function GrowthBookWrapper(props: React.PropsWithChildren) {
  useEffect(() => {
    // Load features asynchronously when the app renders
    growthbook
      .loadFeatures({
        autoRefresh: true,
        timeout: 2000,
      })
      .then(() => {
        gbResponses.sdkData = growthbook.getFeatures();

        growthbook.setFeatures({
          ...growthbook.getFeatures(),
          ...getLocalOnlyFeatures(),
        });
      })
      .catch((err) => {
        gbResponses.sdkErrorMsg = err.message;

        console.log('Error while load GrowthBook features');
      })
      .finally(() => {
        let isFetchDataEmpty = false;
        let isSdkDataEmpty = false;

        if (getKeys(gbResponses.fetchData).length === 0) {
          isFetchDataEmpty = true;
        }
        if (getKeys(gbResponses.sdkData).length === 0) {
          isSdkDataEmpty = true;
        }

        if (
          gbResponses.isFetchDone &&
          (gbResponses.fetchErrorMsg.length || gbResponses.sdkErrorMsg.length || isFetchDataEmpty || isSdkDataEmpty)
        ) {
          console.log('growthbook proxy features responses');
        }
      });
  }, []);

  return <GrowthBookProvider growthbook={growthbook}>{props.children}</GrowthBookProvider>;
}

// eslint-disable-next-line no-restricted-imports
export * from '@growthbook/growthbook-react';

export const useGrowthBook = (): GrowthBook<AppFeatures> | undefined => _useGrowthBook<AppFeatures>();
export const useFeatureIsOn = (id: keyof AppFeatures & string): boolean => _useFeatureIsOn<AppFeatures>(id);
